import { onClickOutside, toggleDialog } from "../../utils";
import { setupBurgerMenu } from "./burger-menu";
import { setupDesktopMenu } from "./desktop-menu";
import { setupResponsiveHandler } from "./responsive-handler";
import { isContactButton } from "./utils";

export const handleNavigation = () => {
  // Get DOM elements
  const header = document.querySelector("[data-nav-header]");
  const burgerMenu = document.getElementById("primary-menu-toggle");
  const navList = document.getElementById("primary-menu");
  const childMenuTogglers = document.querySelectorAll("[data-nav-toggler]");
  const fullPageOverlayControl = document.getElementById("full-page-overlay")
    ?.firstElementChild as HTMLButtonElement;

  // Setup overlay control
  fullPageOverlayControl?.addEventListener("click", () =>
    toggleDialog(fullPageOverlayControl.parentElement, false),
  );

  // Setup navigation components
  setupBurgerMenu(burgerMenu, navList, fullPageOverlayControl);
  setupDesktopMenu(childMenuTogglers, fullPageOverlayControl);
  setupResponsiveHandler(navList, burgerMenu, fullPageOverlayControl);

  // Handle anchor link clicks
  setupAnchorLinkHandler(
    navList,
    burgerMenu,
    childMenuTogglers,
    fullPageOverlayControl,
  );

  // Handle click outside
  setupClickOutsideHandler(
    header,
    navList,
    childMenuTogglers,
    fullPageOverlayControl,
  );
};

const setupAnchorLinkHandler = (
  navList: HTMLElement | null,
  burgerMenu: HTMLElement | null,
  childMenuTogglers: NodeListOf<Element>,
  fullPageOverlayControl: HTMLButtonElement | null,
) => {
  navList?.addEventListener("click", (event) => {
    const target = event.target as HTMLElement;
    const href = target.getAttribute("href");

    if (
      target.tagName === "A" &&
      href &&
      href.split("/").pop()?.startsWith("#")
    ) {
      // Close mobile menu
      navList.classList.add("hidden");
      burgerMenu?.setAttribute("aria-expanded", "false");
      toggleDialog(fullPageOverlayControl?.parentElement, false);

      // Reset desktop menus
      childMenuTogglers.forEach((toggler) => {
        toggler.classList.remove("title-border");
        toggler.setAttribute("aria-expanded", "false");
        toggler.nextElementSibling?.classList.add("lg:hidden");
        toggler.nextElementSibling?.classList.remove("lg:flex");
      });
    }
  });
};

const setupClickOutsideHandler = (
  header: Element | null,
  navList: HTMLElement | null,
  childMenuTogglers: NodeListOf<Element>,
  fullPageOverlayControl: HTMLButtonElement | null,
) => {
  onClickOutside(header as HTMLElement, () => {
    if (window.matchMedia("(min-width: 1240px)").matches) {
      // Desktop: close all menus
      for (const toggler of childMenuTogglers) {
        toggler.classList.remove("title-border");
        toggler.nextElementSibling?.classList.remove("lg:flex");
        toggler.nextElementSibling?.classList.add("lg:hidden");

        if (isContactButton(toggler)) {
          toggler.classList.remove("bg-accent");
          toggler.classList.add("lg:bg-primary");
        }
      }
    } else {
      // Mobile: close menu
      navList?.classList.add("hidden");
    }

    toggleDialog(fullPageOverlayControl?.parentElement, false);
  });
};

